<div class="login-container min-vh-100 d-flex">
  <div class="row w-100 m-0">
    <!-- Left Panel - Form -->
    <div class="col-xl-5 col-lg-6 form-panel d-flex align-items-center justify-content-center p-4">
      <div class="w-100 login-card" style="max-width: 440px;">
        <!-- Logo and Title -->
        <div class="d-flex align-items-center justify-content-center gap-3 mb-4">
          <img src="assets/img/activitypro-logo.png" alt="ActivityPro Logo" class="brand-logo-img" style="height: 40px;" />
          <h1 class="brand-title h3 fw-bold mb-0">ActivityPro</h1>
        </div>

        <div class="text-center mb-4">
          <p class="form-subtitle mb-2">{{ subtitle() }}</p>
          @if (title()) {
            <h2 class="form-title h4 fw-bold">{{ title() }}</h2>
          }
        </div>

        <!-- Page-specific form body -->
        <ng-content></ng-content>

        <div class="contact-info d-flex align-items-center gap-2 mt-3 p-2 rounded-3 w-auto small fw-bold">
          <i class="fa fa-envelope" aria-hidden="true"></i>
          <span>Mail us at:</span>
          <a href="mailto:europe@activitypro.co.uk" class="text-decoration-none">europe&#64;activitypro.co.uk</a>
        </div>

        <div class="form-footer d-flex justify-content-between align-items-center border-top mt-3 pt-3">
          <p class="mb-0 small">&copy; ActivityPro {{ presentYear() }}</p>
          <div class="d-flex gap-3">
            <a href="https://www.facebook.com/ActivityPro" target="_blank" rel="noopener noreferrer" class="social-icon" pTooltip="Facebook" tooltipPosition="top" aria-label="ActivityPro on Facebook">
              <i class="fab fa-facebook-f" aria-hidden="true"></i>
            </a>
            <a href="https://www.instagram.com/activitypro/" target="_blank" rel="noopener noreferrer" class="social-icon" pTooltip="Instagram" tooltipPosition="top" aria-label="ActivityPro on Instagram">
              <i class="fab fa-instagram" aria-hidden="true"></i>
            </a>
            <a href="https://www.linkedin.com/company/activityproapp" target="_blank" rel="noopener noreferrer" class="social-icon" pTooltip="LinkedIn" tooltipPosition="top" aria-label="ActivityPro on LinkedIn">
              <i class="fab fa-linkedin-in" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Panel - Video Section -->
    <div class="col-xl-7 col-lg-6 welcome-panel d-flex align-items-center justify-content-center p-0 position-relative overflow-hidden">
      <video #videoPlayer class="w-100 h-100 position-absolute top-0 start-0" style="object-fit: cover;" autoplay loop muted playsinline [muted]="true" aria-hidden="true">
        <source src="https://www.activitypro.co.uk/wp-content/uploads/2021/01/activity-pro-clubscoaches.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
      @if (ui.isNew()) {
        <div class="nu-editorial">
          <div><img class="nu-editorial-mark" src="assets/img/activitypro-logo.png" alt="" /></div>
          <div>
            <p class="nu-editorial-heading">Great clubs.<br>Stronger<br>communities.</p>
            <p class="nu-editorial-text">Bring your people, your activities and your ambitions together. All with ActivityPro.</p>
          </div>
        </div>
      }
    </div>
  </div>
</div>
